import React from 'react';
import { ChatMessage as ChatMessageType } from '../types/chat';

interface ChatMessageProps {
  message: ChatMessageType;
}

const ChatMessage: React.FC<ChatMessageProps> = ({ message }) => {
  const getMessageClass = () => {
    let baseClass = 'message';
    if (message.sender === 'user') baseClass += ' user';
    else if (message.sender === 'agent') baseClass += ' agent';
    else baseClass += ' system';
    if (message.isError) baseClass += ' error';
    return baseClass;
  };

  const formatTime = (timestamp: string) => {
    return new Date(timestamp).toLocaleTimeString([], { 
      hour: '2-digit', 
      minute: '2-digit' 
    });
  };

  return (
    <div className={getMessageClass()}>
      <div className="message-content">
        {message.content}
      </div>
      <div className="message-timestamp">
        {formatTime(message.timestamp)}
        {message.status && (
          <span className={`message-status ${message.status}`}>
            {message.status === 'sending' && ' ⏳'}
            {message.status === 'sent' && ' ✓'}
            {message.status === 'error' && ' ✗'}
          </span>
        )}
      </div>
    </div>
  );
};

export default ChatMessage;